import { API_MODE, delay } from "./helpers";
import { request } from "./http";
import { paths } from "./wire";

/**
 * What the signed-in caller IS, from the platform (the sponsor, 2026-10-14:
 * "anything the platform admin needs should be taken to its own page"; the
 * coordinator's design, the same day). GET /v1/session/capabilities.
 *
 * NEVER GUESSED FROM THE TOKEN. dev-user, the platform operator, is also the
 * gate's fixture user, joined to an organisation that holds no rows, so its
 * token carries an org_id although it has no organisation to use. The platform
 * answers `organisation_id` ONLY for an organisation that resolves.
 */
export interface SessionCapabilities {
  platformOperator: boolean;
  /** Present only when the caller's organisation resolves. */
  organisationId?: string;
}

export class SessionCapabilitiesShapeError extends Error {}

/** Strict: `platform_operator` must be a boolean; `organisation_id` a non-empty string, or absent/null. */
export function sessionCapabilitiesFromWire(raw: unknown): SessionCapabilities {
  if (!raw || typeof raw !== "object") throw new SessionCapabilitiesShapeError("the session's capabilities are not an object");
  const { platform_operator: op, organisation_id: org } = raw as Record<string, unknown>;
  if (typeof op !== "boolean") throw new SessionCapabilitiesShapeError("platform_operator is not a boolean");
  if (org !== undefined && org !== null && (typeof org !== "string" || org === "")) {
    throw new SessionCapabilitiesShapeError("organisation_id is not an id");
  }
  return { platformOperator: op, ...(typeof org === "string" ? { organisationId: org } : {}) };
}

export async function getSessionCapabilities(): Promise<SessionCapabilities> {
  // ONE return statement, so a production build drops the mock branch below.
  if (API_MODE === "http") return sessionCapabilitiesFromWire(await request<unknown>(paths.sessionCapabilities()));
  await delay(60);
  // The mock console is a tenant user of the mock organisation.
  return { platformOperator: false, organisationId: "mock-org" };
}
